import { AuthShell } from '@/Ship/Components/Auth/AuthShell'
import { PhoneLoginForm } from '@/Ship/Components/Auth/PhoneLoginForm'

/**
 * Форма входу для неавторизованого користувача на внутрішньому URL
 * (`templateError403` у DefaultLayoutTemplate).
 *
 * Це найчастіший шлях до входу — на застосунок заходять із закладки, а не з
 * `/public/login`, — тож оболонка й форма тут ті самі, що й на публічній
 * сторінці: вхід за телефоном із нормалізацією (`SPEC-014` §2.1).
 */
export const LoginPageTemplate = () => (
    <AuthShell>
        <PhoneLoginForm stayOnPage />
    </AuthShell>
)
